<template>
  <section>
    <div class="mod-block">
      <h3 class="title">DIFF值组<span>（至少填写一组）</span></h3>
      <el-form ref="form" :model="formDiff" label-width="80px" size="mini" class="mod-form">
        <div class="groups" v-for="(item, index) in formDiff.list" :key="index">
          <el-form-item label="类型" :prop="'list.'+index+'.v1'" :rules="[
            {validator: validateDiff, index: index},
            {validator: $validate.required, noRequired: !item.v2}
          ]">
            <el-select v-model="item.v1" @change="change(item)" clearable>
              <el-option :value="item2.diffType" :label="item2.diffTypeDesc" v-for="(item2, index2) in selectAr" :key="index2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="差异组" :prop="'list.'+index+'.v2'" :rules="[
            {validator: $validate.required, noRequired: !item.v1}
          ]">
            <el-select v-model="item.v2" @change="change2(item)" clearable>
              <el-option :value="item2.diffGroupId" :label="item2.diffGroupDesc" v-for="(item2, index2) in Object.values(item.map2)" :key="index2"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item prop="list" class="mod-tips" :rules="[{validator: validateRepeat}]" label-width="0px"></el-form-item>
      </el-form>
    </div>
  </section>
</template>
<script>
  export default {
    inject: ['getComData', 'getMod'],
    data () {
      return {
        formDiff: {
          list: []
        },
        // 接口字段
        form: {
          map: []
        },
        // 第一级key,value对
        formAr: [
          ['diffKeyOne', 'diffValueOne'],
          ['diffKeyTwo', 'diffValueTwo'],
          ['diffKeyThree', 'diffValueThree'],
          ['diffKeyFour', 'diffValueFour']
        ],
        selectMap1: {}, // 一级map
        selectAr: []
      }
    },
    methods: {
      validateRepeat (rule, value, callback) {
        let ar1 = this.formDiff.list.map(item => item.v1).filter(item => item)
        let ar2 = [...new Set(ar1)]
        if (ar1.length > 0 && ar1.length !== ar2.length) {
          callback(new Error('类型不能重复'))
        }
        callback()
      },
      change (item, isEdit) {
        return this.$ajax.post('/rmsinteractservice/rms/getDiffGroupHead', {diffType: item.v1, __isRP: false}).then(rs => {
          if (rs && rs.code == 0) {
            let ar = rs.result
            item.map2 = {}
            item.map3 = {}
            ar.forEach(item1 => {
              this.$set(item.map2, item1.diffGroupId, item1)
            })
            if (!isEdit) {
              item.v2 = ''
              item.v3 = ''
              this.$emit('updated')
            }
            this.formateFormData()
          }
        })
      },
      change2 (item, isEdit) {
        let ar2 = item.map2[item.v2].detailList || []
        item.map3 = {}
        ar2.forEach(item2 => {
          this.$set(item.map3, item2.diffType, item2)
        })
        if (!isEdit) {
          item.v3 = ''
          this.$emit('updated')
        }
        this.formateFormData()
      },
      // 转换成后端所需数据
      formateFormData () {
        let ar = this.formDiff.list || []
        let map = {}
        let keys = this.formAr
        ar.forEach((item, index) => {
          let textKey = keys[index][0]
          let valueKey = keys[index][1]
          if (this.selectMap1[item.v1]) {
            map[valueKey] = item.v1
            map[textKey] = this.selectMap1[item.v1].diffTypeDesc
          }
        })
        this.form.map = map
      },
      // 至少填写一组
      validateDiff (rule, value, callback) {
        if (rule.index !== 0) {
          callback()
          return
        }
        let flag = false
        for (let i = 0; i < this.formDiff.list.length; i++) {
          let item = this.formDiff.list[i]
          let firstDegree = item.v1
          let secondDegree = item.v2
          if (firstDegree && secondDegree) {
            flag = true
            break
          }
        }
        if (flag) {
          callback()
        } else {
          callback(new Error(' '))
        }
      },
      cloneObj (obj) {
        return JSON.parse(JSON.stringify(obj))
      }
    },
    mounted () {
      // 编辑
      let $itemChildDiffList = this.getMod('itemChildDiffList')
      let {editData} = this.getComData()
      let ar2 = this.cloneObj(editData.itemChildDiffList || [])
      let form2 = ar2[0] || {}
      let formAr3 = $itemChildDiffList.formAr3
      let num = 0
      if (editData.itemDiffModel) {
        Object.assign(this.form.map, this.cloneObj(editData.itemDiffModel))
        let len = this.formAr.filter(item => this.form.map[item[1]]).length
        for (let i = 0; i < 4; i++) {
          let obj = {v1: '', v2: '', v3: '', map2: {}, map3: {}, degree: i}
          let k1 = this.formAr[i][1] // 找到v1对应的后端key值
          let k3 = formAr3[i][1] // 找到v3对应的后端key值
          // 一级
          if (this.form.map[k1]) {
            obj['v1'] = this.form.map[k1]
            // 二级
            if (form2[k1]) {
              obj['v2'] = form2[k1]
            }
            // 获取二级map，三级map
            this.change(obj, true).then(rs => {
              num++
              this.change2(obj, true)
              if (num == len) {
                this.$emit('loaded')
              }
            })
          }
          this.$set(this.formDiff.list, i, obj)
        }
      } else {
        // 新增
        for (let i = 0; i < 4; i++) {
          this.$set(this.formDiff.list, i, {v1: '', v2: '', v3: '', map2: {}, map3: {}, degree: i})
        }
      }
      // 获取下拉框列表
      this.$ajax.get('/rmsinteractservice/rms/getDiffType').then(rs => {
        if (rs.code == 0) {
          this.selectAr = rs.result || []
          this.selectAr.forEach((item, index) => {
            this.$set(this.selectMap1, item.diffType, item)
          })
        }
      })
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 0px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      span {
        color: #999;
        font-size: 12px;
        font-weight: normal;
      }
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
    .groups {
      overflow: hidden;
    }
  }
  .mod-form {
    .el-form-item {
      float: left;
      width: 190px;
      margin-bottom: 12px!important;
      border: 1px solid #ddd;
      padding: 3px;
      border-radius: 3px;
      margin-right: 10px;
    }
    /deep/ .label-text .el-form-item__label {
      line-height: 14px;
    }
    /deep/ .el-form-item__label {
      text-align: center;
      padding: 0 0 0 0;
    }
    /deep/ .el-input__inner {
      width: 100px;
    }
    /deep/ .el-form-item__content {
      font-size: 12px;
    }
    .mod-tag {
      background: #8400FF;
      color: #fff;
      border-radius: 4px;
      font-size: 12px;
      font-style: normal;
      padding: 2px;
    }
    .btns {
      float: left;
      padding-top: 4px;
    }
  }
  .mod-tips {
    border: 0!important;
    float: none!important;
    padding: 0px!important;
    margin: 0px!important;
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/diff/diff-group.vue